<div class="flex flex-col h-full">
    <app-toolbar></app-toolbar>

    <main class="bg-gray-50 flex-1">
        <router-outlet></router-outlet>
    </main>
</div>
